module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/passthrough.js
// module id = 276
// module chunks = 0